import ApiBase from '../ApiBase';

class Services extends ApiBase {
    route = '/services';
}

export default new Services();
